var _path, _path2, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBaixarApp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.672 31.7H12.625a1.083 1.083 0 01-1.082-1.082V27.64a1.083 1.083 0 012.165 0v1.894h12.881v-1.894a1.083 1.083 0 012.165 0v2.977c0 .597-.485 1.082-1.083 1.082z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.138 19.893a1.082 1.082 0 00-1.53 0l-4.323 4.323V11.782a1.083 1.083 0 00-2.165 0V24.27l-4.322-4.322a1.082 1.082 0 10-1.531 1.53l6.17 6.17a1.08 1.08 0 001.53 0c.07-.069 6.171-6.224 6.171-6.224a1.082 1.082 0 000-1.53z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.043,
    y: 1.2,
    width: 39,
    height: 39,
    rx: 3.5,
    stroke: "#fff"
  })));
}

export default "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.12/_next/static/images/baixar-app-e9b7a1dc4821b373eb29d7446be39101.svg";
export { SvgBaixarApp as ReactComponent };